module Client.Components.PurchaseOrderNumberInfo

open Shared
open global.Elmish
open Feliz
open Feliz.MaterialUI
open CustomerDexImaging.Models

let view (purchaseOrderNumber : string) =
  Html.div [
    Mui.grid [
      grid.container true
      grid.direction.column
      grid.spacing._2
      grid.children [
        Mui.grid [
          grid.item true
          grid.children [
            Mui.textField [
              textField.placeholder "Purchase order number"
              textField.value purchaseOrderNumber
              textField.variant.filled
              textField.margin.normal
              textField.fullWidth true
              textField.label "Purchase order number"
              textField.name "PurchaseOrderNumber"
            ]
          ]
        ]
      ]
    ]
  ]